$(function () {
    "use strict";

    if (!Modernizr.touch && !$('html').hasClass('lt-ie9')) {

        var $root          = $('.discussion-page'),
            $floatingPanes = $root.find('.discussion-page__right:not(.discussion-page__right_static)');

        if ($floatingPanes.length > 0) {
            var padding = 16,
                maxWidth = parseFloat($('.b-root').css('min-width') || 1235);

            var getStuck = function($pane) {

                $pane.wrapInner('<div class="discussion-page__floating-pane"></div>');
                var $stackable = $pane.find('.discussion-page__floating-pane');
                var bottomElm = $root.find('.discussion-page__sticky-bottom');

                $stackable.css('margin-bottom', padding);

                var previousScrollLeft = $(window).scrollLeft(),
                    previousWindowWidth = $(window).width(),
                    previousStackableHeight = 0,
                    previousHeaderState = false,
                    previousPaneHeight = 0;

                var recalc = function (isHard) {

                    var isHeaderSticked = function() {
                        return $(window).width() >= maxWidth;
                    };
                    var isFixed = function() {
                        return $stackable.css('position') == 'fixed';
                    };
                    var getPaneHeight = function (bottomElm) {
                        return bottomElm.offset().top - $pane.offset().top + padding;
                    };
                    var getStackableHeight = function () {
                        $stackable.height('');
                        return $stackable.height();
                    };
                    var leftOffset = function() {
                        return $pane.offset().left + (parseInt($pane.css('padding-left')) || 0)
                    };
                    var getStackableLeft = function () {
                        return isFixed() ? leftOffset() - $(window).scrollLeft() : '';
                    };
                    var getPaneMarginTop = function () {
                        return isHeaderSticked() ? -1 * (padding + 40): -1 * padding;
                    };
                    var getStackableMarginTop = function () {
                        return isHeaderSticked() ? padding + 40 : padding;
                    };

                    var scrollLeft = $(window).scrollLeft(),
                        windowWidth = $(window).width(),
                        paneHeight = getPaneHeight(bottomElm),
                        stackableHeight = getStackableHeight(),
                        headerState = isHeaderSticked();

                    if (scrollLeft != previousScrollLeft || windowWidth != previousWindowWidth) {
                        previousScrollLeft = scrollLeft;
                        previousWindowWidth = windowWidth;
                        $stackable.css('left', getStackableLeft());
                    }

                    if (paneHeight != previousPaneHeight) {
                        previousPaneHeight = paneHeight;
                        $pane.css({
                            height: paneHeight
                        });
                    }

                    if (stackableHeight != previousStackableHeight) {
                        previousStackableHeight = stackableHeight;
                        $stackable.css({
                            height: stackableHeight
                        });
                    }

                    if (headerState != previousHeaderState) {
                        previousHeaderState = headerState;
                        $pane.css({
                            marginTop: getPaneMarginTop()
                        });

                        $stackable.css({
                            marginTop: getStackableMarginTop()
                        });
                    }

                    if (isHard) {
                        $(document.body).trigger('sticky_kit:recalc');
                    }
                };

                recalc();
                $stackable.stick_in_parent();
                $(window).on('load debouncedresize Header::recalc Sidebar::recalc LazyLoad::load', function() {
                    recalc(true);
                });

                window.sidebarRecalc = function() {
                    $(window).trigger('debouncedresize');
                };
            };

            $floatingPanes.each(function() {
                getStuck($(this));
            });
        }
    }
});
